<template name="deviceDetailedVariable">
  <div>
    <div v-if="show == 0">
      <!-- 搜索部分 -->
      <div style="display: flex;justify-content: center;">
        <el-input style="width: 60%;margin-right: 10px"
                  placeholder="输入变量名称搜索"
                  v-model="variableName"
                  clearable>
        </el-input>
        <el-button icon="el-icon-search" circle @click="getDeviceVariable"></el-button>
      </div>
      <div style="margin-top: 10px;">
        <el-table :data="table" style="width: 100%;text-align: center; height: 100%; " border ref="refTable"
                  :header-cell-style="{ background: '#F2F2F2', color: '#333' }">
          <el-table-column prop="variableName" label="变量名称" width="200" show-overflow-tooltip align="center"/>
          <el-table-column prop="VariablePort" label="端口号" width="200" show-overflow-tooltip align="center"/>
          <el-table-column prop="curValue" label="当前值" min-width="50" show-overflow-tooltip align="center"/>
          <el-table-column prop="lastupdate_time" label="更新时间" min-width="50" show-overflow-tooltip align="center"/>
          <el-table-column prop="deviceType" label="数据类型" min-width="50" show-overflow-tooltip align="center">
            <template v-slot="scope">
              <span v-if="scope.row.variableType == 0">整数</span>
              <span v-if="scope.row.variableType == 1">小数</span>
            </template>
          </el-table-column>
          <el-table-column  label="详情" width="100" align="center">
            <template v-slot="scope">
              <el-button @click="handleClick(scope.row)" type="primary" size="small">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div v-if="show == 1">
      <el-card>
        <div slot="header"  style="font-size: 40px;color: #004768">
          <span>变量信息-变量{{ variableNow.id }}</span>
        </div>
        <div>
          <div style="display:flex;align-items: center;">
            <div class="info-title">变量名称：</div>
            <div class="info-content">{{ variableNow.variableName }}</div>
            <i class="el-icon-edit" color="#00aaff" style="margin-left: 10px;"
               @click="handleEditIdBtnClick7()"/>
          </div>
          <hr style="margin-top: 10px;margin-bottom: 20px;"/>
          <div style="display:flex;align-items: center;">
            <div class="info-title">变量描述：</div>
            <div class="info-content">{{ variableNow.description }}</div>
            <i class="el-icon-edit" color="#00aaff" style="margin-left: 10px;"
               @click="handleEditIdBtnClick8()"/>
          </div>

          <hr style="margin-top: 10px;margin-bottom: 20px;"/>
          <div style="display:flex;align-items: center;">
            <div class="info-title">数据类型：</div>
            <div v-if="variableNow.variableType == 0" class="info-content">
              整数
            </div>
            <div v-if="variableNow.variableType == 1" class="info-content">
              小数
            </div>
            <i class="el-icon-edit" color="#00aaff" style="margin-left: 10px;"
               @click="handleEditIdBtnClick9()"/>
          </div>
          <div v-if="variableNow.variableType == 1">
            <hr style="margin-top: 10px;margin-bottom: 20px;"/>
            <div style="display:flex;align-items: center;">
              <div class="info-title">小数位数：</div>
              <div class="info-content">{{ variableNow.decimalNum }}</div>
              <i class="el-icon-edit" color="#00aaff" style="margin-left: 10px;"
                 @click="handleEditIdBtnClick10()"/>
            </div>
          </div>
          <hr style="margin-top: 10px;margin-bottom: 20px;"/>
          <div style="display:flex;align-items: center;">
            <div class="info-title">编码类型：</div>
            <div v-if="variableNow.codeType == 0" class="info-content">
              x1,x2,x3,x4
            </div>
            <div v-if="variableNow.codeType == 1" class="info-content">
              x4,x3,x2,x1
            </div>
            <div v-if="variableNow.codeType == 2" class="info-content">
              x2,x1,x4,x3
            </div>
            <div v-if="variableNow.codeType == 3" class="info-content">
              x3,x4,x1,x2
            </div>
            <i class="el-icon-edit" color="#00aaff" style="margin-left: 10px;"
               @click="handleEditIdBtnClick11()"/>
          </div>
          <hr style="margin-top: 10px;margin-bottom: 20px;"/>
          <div style="display:flex;align-items: center;">
            <div class="info-title">报警类型：</div>
            <div v-if="variableNow.alertType == 0" class="info-content">
              不报告
            </div>
            <div v-if="variableNow.alertType == 1" class="info-content">
              报警仅记录报告信息
            </div>
            <div v-if="variableNow.alertType == 2" class="info-content">
              报警记录报告信息并且短信提醒
            </div>
            <i class="el-icon-edit" color="#00aaff" style="margin-left: 10px;"
               @click="handleEditIdBtnClick4()"/>
          </div>
          <div v-if="variableNow.alertType != 0">
            <hr style="margin-top: 10px;margin-bottom: 20px;"/>
            <div style="display:flex;align-items: center;">
              <div class="info-title">报警上限：</div>
              <div class="info-content">{{ variableNow.highAlertValue }}</div>
              <i class="el-icon-edit" color="#00aaff" style="margin-left: 10px;"
                 @click="handleEditIdBtnClick2()"/>
            </div>
            <hr style="margin-top: 10px;margin-bottom: 20px;"/>
            <div style="display:flex;align-items: center;">
              <div class="info-title">报警下限：</div>
              <div class="info-content">{{ variableNow.lowAlertValue }}</div>
              <i class="el-icon-edit" color="#00aaff" style="margin-left: 10px;"
                 @click="handleEditIdBtnClick3()"/>
            </div>
          </div>
          <div v-if="variableNow.alertType == 2">
            <hr style="margin-top: 10px;margin-bottom: 20px;"/>
            <div style="display:flex;align-items: center;">
              <div class="info-title">报警号码：</div>
              <div class="info-content">
                {{ variableNow.alertPhone }}
              </div>
              <i class="el-icon-edit" color="#00aaff" style="margin-left: 10px;"
                 @click="handleEditIdBtnClick5()"/>
            </div>
          </div>
          <hr style="margin-top: 10px;margin-bottom: 20px;"/>
          <div style="display:flex;align-items: center;">
            <div class="info-title">变量日志：</div>
            <div v-if="variableNow.his_log == 0" class="info-content">
              不记录历史值
            </div>
            <div v-if="variableNow.his_log == 1" class="info-content">
              记录历史值
            </div>
            <i class="el-icon-edit" color="#00aaff" style="margin-left: 10px;"
               @click="handleEditIdBtnClick6()"/>
          </div>
          <hr style="margin-top: 10px;margin-bottom: 20px;"/>
          <div style="display:flex;align-items: center;">
            <div class="info-title">端口号：</div>
            <div class="info-content">
              {{ variableNow.VariablePort }}
            </div>
          </div>
          <hr style="margin-top: 10px;margin-bottom: 20px;"/>
          <div style="display:flex;align-items: center;">
            <div class="info-title">当前值：</div>
            <div class="info-content">
              {{ variableNow.curValue }}
            </div>
          </div>
          <hr style="margin-top: 10px;margin-bottom: 20px;"/>
          <div style="display:flex;align-items: center;">
            <div class="info-title">更新时间：</div>
            <div class="info-content">
              {{ variableNow.lastupdate_time }}
            </div>
          </div>
          <hr style="margin-top: 10px;margin-bottom: 20px;"/>
          <div style="display:flex;align-items: center;">
            <div class="info-title">创建者：</div>
            <div class="info-content">
              {{ variableNow.UserName }}
            </div>
          </div>
          <hr style="margin-top: 10px;margin-bottom: 20px;"/>
          <div style="display:flex;align-items: center;">
            <div class="info-title">创建时间：</div>
            <div class="info-content">
              {{ variableNow.create_time }}
            </div>
          </div>
        </div>
      </el-card>
      <el-dialog title="修改变量名称" :visible.sync="nameShow">
        <el-form :model="changeList">
          <el-form-item label="变量名称" label-width="120px">
            <el-input v-model="changeList.tempName" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="nameShow=false">取 消</el-button>
          <el-button type="primary" @click="nameShow=false;handleConfirmBtnClick();">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="修改变量描述" :visible.sync="descriptionShow">
        <el-form :model="changeList">
          <el-form-item label="变量描述" label-width="120px">
            <el-input v-model="changeList.tempDescription" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="descriptionShow=false">取 消</el-button>
          <el-button type="primary" @click="descriptionShow=false;handleConfirmBtnClick();">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="修改报警上限" :visible.sync="highShow">
        <el-form :model="changeList">
          <el-form-item label="报警上限" label-width="120px">
            <el-input v-model="changeList.tempHigh" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="highShow=false">取 消</el-button>
          <el-button type="primary" @click="highShow=false;handleConfirmBtnClick();">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="修改报警下限" :visible.sync="lowShow">
        <el-form :model="changeList">
          <el-form-item label="报警下限" label-width="120px">
            <el-input v-model="changeList.tempLow" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="lowShow=false">取 消</el-button>
          <el-button type="primary" @click="lowShow=false;handleConfirmBtnClick();">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 修改当前值的模态窗 -->
      <el-dialog title="修改当前值" :visible.sync="curValueShow">
        <el-form :model="changeList">
          <el-form-item label="当前值" label-width="120px">
            <el-input v-model="changeList.tempCurValue" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="curValueShow=false">取 消</el-button>
          <el-button type="primary" @click="lowShow=false;handleConfirmBtnClick();">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 修改报警电话的模态窗 -->
      <el-dialog title="报警电话" :visible.sync="alertPhoneShow">
        <el-form :model="changeList">
          <el-form-item label="报警电话" label-width="120px">
            <el-input v-model="changeList.tempAlertPhone" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="alertPhoneShow=false">取 消</el-button>
          <el-button type="primary" @click="alertPhoneShow=false;handleConfirmBtnClick();">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 修改报警类型的模态窗 -->
      <el-dialog title="修改报警类型" :visible.sync="alertTypeShow">
        <el-radio v-for="(item, index) in list" v-model="changeList.tempAlertType" :label="index" :key="index">
          {{ item.name }}
        </el-radio>
        <div slot="footer" class="dialog-footer">
          <el-button @click="alertTypeShow=false">取 消</el-button>
          <el-button type="primary" @click="alertTypeShow=false;handleConfirmBtnClick();">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 修改数据类型的模态窗 -->
      <el-dialog title="修改数据类型" :visible.sync="variableTypeShow">
        <el-radio v-for="(item, index) in typeList" v-model="changeList.tempVariableType" :label="index" :key="index">
          {{ item.name }}
        </el-radio>
        <div slot="footer" class="dialog-footer">
          <el-button @click="variableTypeShow=false">取 消</el-button>
          <el-button type="primary" @click="variableTypeShow=false;handleConfirmBtnClick();">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 修改小数位数的模态窗 -->
      <el-dialog title="修改小数位数" :visible.sync="decimalNumShow">
        <el-form :model="changeList">
          <el-form-item label="小数位数" label-width="120px">
            <el-input v-model="changeList.tempDecimalNum" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="decimalNumShow=false">取 消</el-button>
          <el-button type="primary" @click="decimalNumShow=false;handleConfirmBtnClick();">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 修改编码类型的模态窗 -->
      <el-dialog title="修改编码类型" :visible.sync="codeTypeShow">
        <el-radio v-for="(item, index) in codeTypeList" v-model="changeList.tempCodeType" :label="index" :key="index">
          {{ item.name }}
        </el-radio>
        <div slot="footer" class="dialog-footer">
          <el-button @click="codeTypeShow=false">取 消</el-button>
          <el-button type="primary" @click="codeTypeShow=false;handleConfirmBtnClick();">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 修改变量日志的模态窗 -->
      <el-dialog title="修改变量日志" :visible.sync="hisLogShow">
        <el-radio v-for="(item, index) in hisLogList" v-model="changeList.tempHisLog" :label="index" :key="index">
          {{ item.name }}
        </el-radio>
        <div slot="footer" class="dialog-footer">
          <el-button @click="hisLogShow=false">取 消</el-button>
          <el-button type="primary" @click="hisLogShow=false;handleConfirmBtnClick();">确 定</el-button>
        </div>
      </el-dialog>
      <el-button type="primary" style="margin-top: 10px" text="确定" @click="returnBack">返回自定义变量列表</el-button>
    </div>
  </div>
</template>

<script>
import API from "@/../config/api.js";

export default {
  name: "deviceDetailedVariable",
  data() {
    return {
      tableSelect: [], //表格选中列表
      table: [],
      variableName: '', //模糊搜索的变量名称

      show: 0,
      variableNow: {}, //记录当前查看的具体变量
      //各个修改窗口的展示控制
      nameShow: false,
      descriptionShow: false,
      highShow: false,
      lowShow: false,
      alertTypeShow: false,
      alertPhoneShow: false,
      curValueShow: false,
      variableTypeShow: false,
      decimalNumShow:false,
      hisLogShow:false,
      codeTypeShow:false,
      //模态窗绑定的变量
      changeList: {
        id: null,
        tempName: null,
        tempDescription: null,
        tempHigh: null,
        tempLow: null,
        tempAlertType: null,
        tempAlertPhone: null,
        tempCurValue: null,
        tempVariableType: null,
        tempDecimalNum: null,
        tempHisLog:null,
        tempCodeType: null,
      },
      list: [{
        name: '不报告',
        disabled: false
      },
        {
          name: '报警仅记录报告信息',
          disabled: false
        },
        {
          name: '报警记录报告信息并且短信提醒',
          disabled: false
        },
      ],
      typeList: [
        {
          name: '整数',
          disabled: false
        },
        {
          name: '小数',
          disabled: false
        },
      ],
      codeTypeList: [
        {
          name: 'x1,x2,x3,x4',
          disabled: false
        },
        {
          name: 'x4,x3,x2,x1',
          disabled: false
        },
        {
          name: 'x2,x1,x4,x3',
          disabled: false
        },
        {
          name: 'x3,x4,x1,x2',
          disabled: false
        },
      ],
      hisLogList:[
        {
          name: '不记录历史值',
          disabled: false
        },{
          name: '记录历史值',
          disabled: false
        }
      ]
    }
  },
  //此处定义传入的数据
  props: {
    companyId: Number,
    deviceId: Number
  },
  mounted() {
    this.getDeviceVariable();
  },
  methods: {
    // 获取当前公司所有的设备，已经调通
    getDeviceVariable() {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }

      let data = {
        companyId: this.companyId,
        deviceType: 1,
        deviceId: this.deviceId,
        variableName: this.variableName
      }
      console.log(data)
      this.$axiosRequest({
        url: API.getVariableList,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          console.log(res.data)
          this.table = res.data["variableList"]

        }
      });
    },
    //清空搜索
    clear() {
      this.searchTitle = '';
      this.getDeviceVariable();
    },
    //返回变量列表
    returnBack() {
      this.show = 0;
      this.getDeviceVariable();
    },
    //跳转到变量具体信息修改
    handleClick(item) {
      this.show = 1;
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }

      let data = {
        companyId: this.companyId,
        id: item.id
      }
      console.log(data)
      this.$axiosRequest({
        url: API.getVariableById,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          console.log(res.data)
          this.variableNow = res.data["variable"]
          this.changeList.tempAlertType = this.variableNow.alertType.toString();
        }
      });
    },
    //调用后端的修改接口
    handleConfirmBtnClick() {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      if (!this.changeList.tempName) {
        this.$message({
          message: '项目名不能为空',
          type: 'none'
        })
        this.nameShow = false
        return
      }
      // if (!Number.isFinite(Number(this.changeList.tempHigh)) && this.changeList.tempHigh != '' && this.changeList.tempHigh != undefined) {
      //   this.$message({
      //     message: '最高报警值请输入数字',
      //     type: 'none'
      //   })
      //   this.highShow = false
      //   return
      // }
      // if (!Number.isFinite(Number(this.changeList.tempLow)) && this.changeList.tempLow != '' && this.changeList.tempLow != undefined) {
      //   this.$message({
      //     message: '最低报警值请输入数字',
      //     type: 'none'
      //   })
      //   this.lowShow = false
      //   return
      // }
      // if (!Number.isFinite(Number(this.changeList.curValue)) && this.changeList.curValue != '' && this.changeList.curValue != undefined) {
      //   this.$message({
      //     message: '当前值请输入数字',
      //     type: 'none'
      //   })
      //   this.curShow = false
      //   return
      // }
      let data = {
        companyId: this.companyId,
        id: this.changeList.id,
        variableName: this.changeList.tempName,
        description: this.changeList.tempDescription,
        highAlertValue: this.changeList.tempHigh,
        lowAlertValue: this.changeList.tempLow,
        alertType: this.changeList.tempAlertType,
        alertPhone: this.changeList.tempAlertPhone,
        curValue: this.changeList.tempCurValue,
        variableType: this.changeList.tempVariableType,
        decimalNum: this.changeList.tempDecimalNum,
        his_log:this.changeList.tempHisLog,
        codeType:this.changeList.tempCodeType
      }
      this.$axiosRequest({
        url: API.updateVariable,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          if (res.data > 0) {
            this.$message({
              message: '修改成功',
              type: 'none'
            });
            this.changeList.id = this.variableNow.id;
            this.handleClick(this.changeList);
            this.getDeviceVariable();
            this.nameShow = false;
            this.descriptionShow = false;
            this.highShow = false;
            this.lowShow = false;
            this.curValueShow = false;
            this.alertPhoneShow = false;
            this.alertTypeShow = false;
            this.variableTypeShow = false;
            this.decimalNumShow = false;
            this.hisLogShow = false;
            this.codeTypeShow = false;
          } else if (res.data == 0) {
            this.$message({
              message: '变量名称已经存在',
              type: 'none'
            });
            this.nameShow = false
            this.descriptionShow = false;
            this.highShow = false;
            this.lowShow = false;
            this.curValueShow = false;
            this.alertPhoneShow = false;
            this.alertTypeShow = false;
            this.variableTypeShow = false;
            this.decimalNumShow = false;
            this.hisLogShow = false;
            this.codeTypeShow = false;
            return
          } else if (res.data == -2) {
            this.$message({
              message: '参数错误',
              type: 'none'
            });
            this.nameShow = false
            this.descriptionShow = false;
            this.highShow = false;
            this.lowShow = false;
            this.curValueShow = false;
            this.alertPhoneShow = false;
            this.alertTypeShow = false;
            this.variableTypeShow = false;
            this.decimalNumShow = false;
            this.hisLogShow = false;
            this.codeTypeShow = false;
            return
          } else if (res.data == -1) {
            this.$message({
              message: '程序错误',
              type: 'none'
            });
            this.nameShow = false
            this.descriptionShow = false;
            this.highShow = false;
            this.lowShow = false;
            this.curValueShow = false;
            this.alertPhoneShow = false;
            this.alertTypeShow = false;
            this.variableTypeShow = false;
            this.decimalNumShow = false;
            this.hisLogShow = false;
            this.codeTypeShow = false;
            return
          }

        }
      });
    },
    handleEditIdBtnClick7() {
      this.updateChangeList()
      this.nameShow = true
    },

    handleEditIdBtnClick8() {
      this.updateChangeList()
      this.descriptionShow = true
    },
    handleEditIdBtnClick2() {
      this.updateChangeList()
      this.highShow = true;
    },
    handleEditIdBtnClick3() {
      this.updateChangeList()
      this.lowShow = true;
    },
    handleEditIdBtnClick6() {
      this.updateChangeList()
      this.hisLogShow = true;
    },
    handleEditIdBtnClick5() {
      this.updateChangeList()
      this.alertPhoneShow = true;
    },
    handleEditIdBtnClick4() {
      this.updateChangeList()
      this.alertTypeShow = true;
    },
    handleEditIdBtnClick9() {
      this.updateChangeList()
      this.variableTypeShow = true;
    },
    handleEditIdBtnClick10(){
      this.updateChangeList()
      this.decimalNumShow = true;
    },
    handleEditIdBtnClick11(){
      this.updateChangeList()
      this.codeTypeShow = true;
    },
    updateChangeList() {
      this.changeList.id = this.variableNow.id;
      this.changeList.tempName = this.variableNow.variableName;
      this.changeList.tempDescription = this.variableNow.description;
      this.changeList.tempHigh = this.variableNow.highAlertValue;
      this.changeList.tempLow = this.variableNow.lowAlertValue;
      this.changeList.tempAlertType = this.variableNow.alertType;
      this.changeList.tempAlertPhone = this.variableNow.alertPhone;
      this.changeList.tempCurValue = this.variableNow.curValue;
      this.changeList.tempVariableType = this.variableNow.variableType;
      this.changeList.tempDecimalNum = this.variableNow.decimalNum;
      this.changeList.tempHisLog = this.variableNow.his_log;
      this.changeList.tempCodeType = this.variableNow.codeType;
    }
  }
}
</script>

<style>
.row-title {
  display: inline-block;
  text-align: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 600;
}

.row-input-box {
}

/* 修改表格默认高度  */
.el-table th,
.el-table td {
  padding: 0 !important;
  height: 60px !important;
  line-height: 60px !important;
}

.el-table th {
  padding: 3px 0px !important;
}

.el-table__header tr,
.el-table__header th {
  padding: 0 !important;
  height: 60px !important;
  line-height: 60px !important;
}

.el-table__body tr,
.el-table__body td {
  padding: 0 !important;
  height: 60px !important;
  line-height: 60px !important;
}

/* 改变表格整行的背景色 */
.el-table .freeze {
  background: #F5A623;
}

.button-group-card {
  margin: 10px 15px 10px 15px;
  padding: 12px;
}

.row-line {
  line-height: 20px;
}

.info-title {
  font-size: 18px;
  font-weight: bold;
  color: #004768;
  font-family: '仿宋';
}

.info-content {
  font-size: 18px;
  font-family: '仿宋';
}

.info-content {
  margin: 10px 0px 10px 10px;
  height: auto;
}
</style>
